module.exports = __webpack_public_path__ + "KaTeX_Math-Italic.ab8e675a.woff2";